import { API_AUTH } from "../../common";

const LoaiPhieuThuChiApi = {
  getList: (params) => API_AUTH.get("api/loaithuchi/danhsach",  params ),
  addOrUpdate: (data) => API_AUTH.post("api/loaithuchi/addorupdate", data),
  changeStatus: (id) => API_AUTH.post("api/loaithuchi/changestatus", id),
  delete:  (id) => API_AUTH.delete(`api/loaithuchi/${id}`),
};

export default LoaiPhieuThuChiApi;
